import { COST_CENTER_ICONS } from './costCenter.constants';

function foldText(value) {
  return String(value ?? '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

/** Palabras clave en español por ícono Feather (id → términos de búsqueda). */
export const COST_CENTER_ICON_TAGS = {
  activity: ['actividad', 'rendimiento', 'kpi', 'metrica'],
  archive: ['archivo', 'historial', 'guardar', 'respaldo'],
  award: ['premio', 'reconocimiento', 'logro', 'medalla'],
  'bar-chart-2': ['grafico', 'estadistica', 'reporte', 'ventas', 'finanzas', 'analisis'],
  book: ['libro', 'contabilidad', 'cuenta', 'registro', 'tributario', 'fiscal', 'legal'],
  briefcase: ['maletin', 'negocio', 'empresa', 'oficina', 'comercial', 'trabajo'],
  box: ['caja', 'paquete', 'inventario', 'producto', 'almacen', 'stock'],
  calendar: ['calendario', 'fecha', 'plazo', 'vencimiento', 'agenda'],
  camera: ['camara', 'foto', 'imagen', 'multimedia'],
  clipboard: ['portapapeles', 'formulario', 'declaracion', 'tributario', 'fiscal', 'tramite', 'sii'],
  clock: ['reloj', 'hora', 'tiempo', 'plazo', 'vencimiento'],
  cloud: ['nube', 'online', 'digital', 'saas', 'remoto'],
  code: ['codigo', 'software', 'ti', 'tecnologia', 'desarrollo', 'programacion'],
  coffee: ['cafe', 'descanso', 'oficina'],
  compass: ['brujula', 'direccion', 'navegacion', 'orientacion'],
  cpu: ['procesador', 'ti', 'tecnologia', 'sistema', 'computador'],
  'credit-card': ['tarjeta', 'pago', 'banco', 'finanzas', 'cobro'],
  database: ['base datos', 'datos', 'almacenamiento', 'ti', 'registro'],
  disc: ['disco', 'media', 'almacenamiento'],
  'dollar-sign': ['dolar', 'dinero', 'moneda', 'finanzas', 'pago', 'tributario', 'impuesto', 'cobro'],
  download: ['descargar', 'exportar', 'bajar', 'archivo'],
  edit: ['editar', 'modificar', 'escribir', 'corregir'],
  file: ['archivo', 'documento', 'tributario', 'fiscal', 'papel', 'factura'],
  film: ['video', 'pelicula', 'multimedia'],
  flag: ['bandera', 'meta', 'pais', 'prioridad'],
  folder: ['carpeta', 'organizar', 'documentos', 'archivo'],
  gift: ['regalo', 'beneficio', 'bonificacion'],
  globe: ['mundo', 'internacional', 'web', 'global', 'pais'],
  grid: ['cuadricula', 'tabla', 'matriz', 'organizar'],
  'hard-drive': ['disco', 'almacenamiento', 'ti', 'backup'],
  headphones: ['audio', 'soporte', 'atencion', 'llamada'],
  heart: ['corazon', 'salud', 'favorito', 'bienestar'],
  home: ['casa', 'hogar', 'inicio', 'sede', 'matriz'],
  image: ['imagen', 'foto', 'galeria'],
  inbox: ['bandeja', 'entrada', 'correo', 'mensajes', 'recibidos'],
  layers: ['capas', 'estructura', 'organizacion', 'niveles'],
  layout: ['diseno', 'interfaz', 'vista', 'pantalla'],
  'life-buoy': ['ayuda', 'soporte', 'respaldo', 'seguridad'],
  link: ['enlace', 'vinculo', 'conexion', 'url'],
  list: ['lista', 'detalle', 'inventario', 'items'],
  lock: ['seguridad', 'bloqueo', 'privado', 'acceso'],
  mail: ['correo', 'email', 'mensaje', 'notificacion'],
  map: ['mapa', 'ubicacion', 'territorio', 'region'],
  'map-pin': ['ubicacion', 'pin', 'local', 'sucursal', 'direccion'],
  monitor: ['monitor', 'pantalla', 'ti', 'oficina', 'escritorio'],
  music: ['musica', 'audio'],
  package: ['paquete', 'envio', 'logistica', 'despacho'],
  paperclip: ['adjunto', 'clip', 'documento', 'enlace'],
  percent: ['porcentaje', 'impuesto', 'tributario', 'iva', 'descuento', 'finanzas', 'retencion'],
  phone: ['telefono', 'llamada', 'contacto', 'movil'],
  'pie-chart': ['grafico', 'circular', 'reporte', 'finanzas', 'distribucion'],
  printer: ['impresora', 'imprimir', 'documento', 'papel'],
  'refresh-cw': ['actualizar', 'sincronizar', 'renovar', 'recargar'],
  save: ['guardar', 'salvar', 'archivo', 'respaldo'],
  search: ['buscar', 'lupa', 'consultar', 'encontrar'],
  server: ['servidor', 'ti', 'infraestructura', 'hosting'],
  settings: ['configuracion', 'ajustes', 'parametrizacion', 'engranaje'],
  shield: ['proteccion', 'seguridad', 'legal', 'cumplimiento', 'tributario', 'fiscal'],
  'shopping-bag': ['compra', 'retail', 'bolsa', 'tienda'],
  'shopping-cart': ['carrito', 'compra', 'venta', 'ecommerce'],
  smartphone: ['movil', 'celular', 'app', 'telefono'],
  star: ['estrella', 'destacado', 'rating', 'favorito'],
  sun: ['sol', 'energia', 'clima', 'dia'],
  tag: ['etiqueta', 'categoria', 'clasificar', 'centro costo'],
  target: ['objetivo', 'meta', 'enfoque', 'estrategia'],
  tool: ['herramienta', 'mantenimiento', 'tecnico', 'reparacion'],
  truck: ['camion', 'transporte', 'logistica', 'envio', 'flete'],
  tv: ['television', 'pantalla', 'media'],
  umbrella: ['paraguas', 'seguro', 'proteccion', 'riesgo'],
  user: ['usuario', 'persona', 'empleado', 'rrhh', 'colaborador'],
  users: ['usuarios', 'equipo', 'grupo', 'rrhh', 'personas'],
  video: ['video', 'reunion', 'grabacion', 'llamada'],
  watch: ['reloj', 'tiempo', 'pulsera'],
  wifi: ['wifi', 'red', 'conectividad', 'internet'],
  zap: ['rayo', 'energia', 'rapido', 'electricidad', 'urgente'],
};

export function filterCostCenterIcons(query) {
  const foldedQuery = foldText(query.trim());
  if (!foldedQuery) return COST_CENTER_ICONS;

  return COST_CENTER_ICONS.filter((iconId) => {
    const idHaystack = foldText(iconId.replace(/-/g, ' '));
    if (idHaystack.includes(foldedQuery)) return true;
    const tags = COST_CENTER_ICON_TAGS[iconId];
    if (!tags?.length) return false;
    return tags.some((tag) => foldText(tag).includes(foldedQuery));
  });
}
